import React from 'react';
// module that catches any error that would crash the app and displays an error page with details instead
// the error boundary has to be a class component (and a simple try/catch as alternative doesnt work): https://reactjs.org/docs/error-boundaries.html
class BasicErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: '' };
	}

	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true, error };
	}

	// componentDidCatch(error, info) {
	// 	// You can also log the error to an error reporting service
	// 	//logErrorToMyService(error, info);
	// }

	render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return (
				<div>
					<h1>Something went wrong.</h1>
					<p>Error: {this.state.error.toString()}</p>
					<p>Stack: {this.state.error?.stack}</p>
				</div>
			);
		}

		return this.props.children;
	}
}

export default BasicErrorBoundary;
